exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "gz-dialog-title-bar{pointer-events:none}gz-dialog-title-bar .md-toolbar-tools{pointer-events:auto}gz-dialog-title-bar .ellipsis{width:90%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!../~/@printos/gazelle/src/components/dialog-title-bar/dialog-title-bar.scss
// module id = 104
// module chunks = 0